export const SDK_VERSION = '7.70.0';
